<template>
  <div class="not-found">
    <h2>not-found</h2>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less"></style>
